import { NavLink } from "react-router-dom";
import {
  LayoutDashboard, Building2, ClipboardCheck, Orbit, Gauge,
  BrainCircuit, Radar, Route, FileText, X,
} from "lucide-react";
import { OrbitWordmark } from "@/components/Brand";
import { cn } from "@/lib/utils";

const NAV = [
  { to: "/app", label: "Executive Dashboard", icon: LayoutDashboard, testid: "nav-dashboard", end: true },
  { to: "/app/profile", label: "Business Profile", icon: Building2, testid: "nav-profile" },
  { to: "/app/assessment", label: "Assessment", icon: ClipboardCheck, testid: "nav-assessment" },
  { to: "/app/business-map", label: "Business Map", icon: Orbit, testid: "nav-business-map" },
  { to: "/app/maturity", label: "Digital Maturity", icon: Gauge, testid: "nav-maturity" },
  { to: "/app/ai-readiness", label: "AI Readiness", icon: BrainCircuit, testid: "nav-ai-readiness" },
  { to: "/app/opportunities", label: "Opportunity Radar", icon: Radar, testid: "nav-opportunities" },
  { to: "/app/roadmap", label: "Transformation Roadmap", icon: Route, testid: "nav-roadmap" },
  { to: "/app/reports", label: "Reports", icon: FileText, testid: "nav-reports" },
];

export function Sidebar({ open, onClose }) {
  return (
    <>
      {open && <div className="fixed inset-0 z-30 bg-black/40 backdrop-blur-sm lg:hidden" onClick={onClose} />}
      <aside
        className={cn(
          "fixed inset-y-0 left-0 z-40 flex w-72 flex-col border-r border-border bg-card transition-transform duration-300 lg:static lg:translate-x-0",
          open ? "translate-x-0" : "-translate-x-full",
        )}
        data-testid="app-sidebar"
      >
        <div className="flex h-16 items-center justify-between border-b border-border px-5">
          <OrbitWordmark subtle size={24} />
          <button onClick={onClose} className="rounded-md p-1.5 text-muted-foreground hover:bg-muted lg:hidden" aria-label="Close menu">
            <X className="h-5 w-5" />
          </button>
        </div>

        <nav className="flex-1 space-y-1 overflow-y-auto px-3 py-4">
          {NAV.map(({ to, label, icon: Icon, testid, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              onClick={onClose}
              data-testid={`${testid}-link`}
              className={({ isActive }) =>
                cn(
                  "group flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium transition-colors duration-200",
                  isActive
                    ? "bg-primary text-primary-foreground shadow-sm"
                    : "text-muted-foreground hover:bg-muted hover:text-foreground",
                )
              }
            >
              <Icon className="h-[18px] w-[18px] shrink-0" />
              <span className="truncate">{label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="border-t border-border px-5 py-4">
          <p className="text-[11px] leading-relaxed text-muted-foreground">
            ORBIT sells clarity about what technology should do next — not AI for its own sake.
          </p>
        </div>
      </aside>
    </>
  );
}
